import { useEffect } from 'react';
import {
  Box,
  Container,
  Grid,
  Toolbar,
  Fab,
  Fade,
} from '@mui/material';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import Sidebar from '../Sidebar/Sidebar';
import FooterEnd from '../Footer/FooterEnd';
import HeaderMainProtected from '../Header/HeaderMainProtected';

export default function PageProtected({ headline, specify, main }) {
  return (
    <>
      <Sidebar />

      <Container
        maxWidth={false}
        disableGutters
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Anchor for scroll-to-top */}
        <Toolbar id="back-to-top-anchor" />

        <Grid
          container
          spacing={{ xs: 2, sm: 3, md: 4 }}
          justifyContent="center"
        >
          {/* Header */}
          <Grid xs={12}>
            <Box
              sx={{
                mt: { xs: 8, sm: 4, md: 0 },
                textAlign: 'center',
              }}
            >
              <HeaderMainProtected
                headline={headline}
                specify={specify}
              />
            </Box>
          </Grid>

          {/* Main Content */}
          <Grid xs={12}>
            <Box
              sx={{
                mt: { xs: 4, sm: 2 },
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {main}
            </Box>
          </Grid>
        </Grid>
      </Container>

      <FooterEnd />

      <ScrollTop>
        <Fab
          size="small"
          aria-label="scroll back to top"
          sx={{
            bgcolor: 'primary.C200',
            color: 'primary.C900',
            '&:hover': { color: 'tertiary.C900' },
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </>
  );
}


/* Helper Function to show button to scroll back to top */

function ScrollTop({ children, targetWindow }) {
  const trigger = useScrollTrigger({
    target: targetWindow,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = () => {
    const anchor = document.querySelector('#back-to-top-anchor');
    anchor?.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center',
    });
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{
          zIndex: 14,
          position: 'fixed',
          bottom: 24,
          right: 24,
          cursor: 'pointer',
        }}
      >
        {children}
      </Box>
    </Fade>
  );
}

